import { useMemo, useState } from "react";
import { ZoneMap } from "./ZoneMap";

const RIVAL = "#64748b";
const C = { x: 1391.9, y: 3605.6 };
const FOCUS = [[C.y - 700, C.x - 1050], [C.y + 700, C.x + 1050]];

const STATES = [
  { key: "owned", label: "Dominada" },
  { key: "active", label: "A ser dominada" },
  { key: "contested", label: "Contestada" },
  { key: "faded", label: "Sem presença" },
];
const MODES = [
  { key: "web", label: "Web/F7" },
  { key: "game", label: "No jogo (blip)" },
];

// zona de exemplo no mesmo formato da API, para o ZoneMap aplicar os mesmos estados visuais
const sampleZone = (state, color) => {
  const org = { color };
  const zone = { id: "preview", name: "Pré-visualização", coords: { ...C, z: 0 }, radius: 260, owner: null, active_war: null };
  if (state === "owned") return { ...zone, owner: org };
  const paused = state !== "active";
  return {
    ...zone,
    active_war: {
      status: "fight", attacker: org, defender: { color: RIVAL }, paused,
      pause_reason: state === "contested" ? "contested" : paused ? "no_presence" : null,
    },
  };
};

const Toggle = ({ items, value, onChange, prefix }) => (
  <div className="inline-flex border border-slate-800" data-testid={`${prefix}-toggle`}>
    {items.map((it) => (
      <button key={it.key} type="button" onClick={() => onChange(it.key)} data-testid={`${prefix}-${it.key}`}
        className={`px-2.5 py-1 font-mono text-[10px] uppercase tracking-wider transition-colors duration-150 ${value === it.key ? "bg-emerald-500/15 text-emerald-300" : "text-slate-500 hover:text-slate-200"}`}>
        {it.label}
      </button>
    ))}
  </div>
);

export const OrgMapPreview = ({ hex, blip }) => {
  const [state, setState] = useState("active");
  const [mode, setMode] = useState("web");
  const valid = /^#[0-9a-fA-F]{6}$/.test(hex);
  const color = mode === "game" ? blip.color?.hex || RIVAL : valid ? hex : RIVAL;
  const zones = useMemo(() => [sampleZone(state, color)], [state, color]);
  return (
    <div className="space-y-2" data-testid="org-map-preview">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span className="font-mono text-[11px] uppercase tracking-widest text-slate-400">Pré-visualização no mapa</span>
        <Toggle items={MODES} value={mode} onChange={setMode} prefix="preview-mode" />
      </div>
      <Toggle items={STATES} value={state} onChange={setState} prefix="preview-state" />
      <ZoneMap zones={zones} height={200} interactive={false} focus={FOCUS} testid="org-preview-map" />
      <p className="font-mono text-[10px] text-slate-500" data-testid="preview-color-label">
        {mode === "game" ? (blip.color ? `Blip #${blip.color.id} · ${blip.color.hex}${blip.auto ? " (automático)" : ""}` : "Blip inválido") : `Cor hex ${valid ? hex : "inválida"}`}
        {state === "contested" && " · rival a cinzento"}
      </p>
    </div>
  );
};
